import { render, staticRenderFns } from "./DigitalReplyTable.vue?vue&type=template&id=6e7f572c&"
import script from "./DigitalReplyTable.vue?vue&type=script&lang=js&"
export * from "./DigitalReplyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports